import { defineStore } from 'pinia'
import http from '@/plugins/api.js'
import globals from '@/plugins/globals'
import { auth } from '@/stores'

export const lookups = defineStore('lookups',{
  id: 'lookups',
  state: () => ({
    lookups: {},
    groups: [],
    timeZones: [],
    countries: [],
    stateProvinces: [],
    languages: []
    }),
  actions: {
    async setLookups(data) {
      let authData = auth();
        let profile = authData.profile;
        let showInactive = false
        if (data.showInactive !== undefined && data.showInactive !== null) {
          showInactive = data.showInactive
        }
        let _keys = data.keys.filter(k => !this.lookups[k])
        if (data.refresh === undefined || data.refresh === null) {
          data.refresh = false
        }
        if (_keys.length || data.refresh) {
          if (data.firm === undefined || data.firm === null) {
            data.firm = profile.firm
          }
          data.countryID = ''
          if (profile.countryID) {
            data.countryID = profile.countryID
          }
          const r = await http.post('lookup/ByKeys', {
              keys: data.keys,
              firm: data.firm,
              countryId:data.countryID,
              showInactive: showInactive
            })
          let _lookups = {}
          for (let key of data.keys) {
            _lookups[key] = []
            if (r.data !== undefined && r.data !== null) {
              for (let lookup of r.data) {
                if (lookup.key === key) {
                  lookup.codename = lookup.name
                  lookup.name = lookup.value || lookup.name
                  lookup.value = lookup.id
                  lookup.isInactive = showInactive
                  _lookups[key].push(lookup)
                }
              }
            }
          }
          this.lookups = JSON.parse(JSON.stringify(Object.assign(this.lookups, _lookups)))
        }
      },
      async getLookupsByGroup(className, group) {
        const r = await http.get(`lookup/ByGroup?className=${className}&group=${group}`)
        this.groups = r.data
      },
      async getOnboardLookups() {
        let showInactive = false
        let keys = ['StateProvince', 'Country', 'TimeZone', 'Language']
        const r = await http.get('lookup/onboardLookups')
        let _lookups = {}
        for (let key of keys) {
          _lookups[key] = []
          if (r.data !== undefined && r.data !== null) {
            for (let lookup of r.data) {
              if (lookup.key === key) {
                lookup.codename = lookup.name
                lookup.name = lookup.value || lookup.name
                lookup.value = lookup.id
                lookup.isInactive = showInactive
                _lookups[key].push(lookup)
              }
            }
          }
        }
        this.lookups = Object.assign({}, this.lookups, _lookups);
      },
      async upsertLookup(lookup) {
        const r = await http.post('lookup/Upsert', lookup)
        lookup.id = r.data
        let section = this.groups.filter(group => group.sectionName === lookup.section)
        if (section.length > 0) {
          let index = section[0].children.findIndex(i => i.id === lookup.id)
          if (index >= 0) {
            section[0].children[index] = lookup
          } else {
            section[0].children.push(lookup)
          }
        }
        return r
      },
      async deleteLookup(lookup) {
        let _lookup = Object.assign({}, lookup)
        _lookup.isActive = false
        const r = await http.post('lookup/Delete', _lookup)
        if (r.data[0].Results === '') {
          try {
            let section = this.groups.filter(group => group.sectionName === lookup.section)
            if (section.length > 0) {
              let index = section[0].children.findIndex(i => i.id === lookup.id)
              section[0].children.splice(index, 1)
            }
          } catch (e) {
            console.error('Error deleting lookup:', e)
          }
        }
        return r
      },
      async upsertGroup(id, name) {
        let data = {
          id: id,
          text: name
        }
        const r = await http.post('lookup/UpsertGroup', data)
        if (r.data === id) {
          let group = this.groups.filter(g => g.id === data.id)
          if (group.length > 0) {
            group[0].sectionName = data.text
          }
        }
        return r
      },
      async setCountries() {
        const r = await http.get('lookup/Countries')
        let _data = globals.sortArray(r.data)
        this.countries = _data
        let _items = []
        for (let item of _data) {
          item.value = parseInt(item.id)
          _items.push(item)
        }
        this.countries = JSON.parse(JSON.stringify(Object.assign(this.countries, _items)))
      },
      async setTimeZones() {
        const r = await http.get('lookup/TimeZones')
        let _data = globals.sortArray(r.data)
        this.timeZones = []
        let _items = []
        for (let item of _data) {
          item.value = parseInt(item.id)
          _items.push(item)
        }
        this.timeZones = JSON.parse(JSON.stringify(Object.assign(this.timeZones, _items)))
        
      },
      async setStateProvinces(id) {
        const r = await http.get(`lookup/StateProvince?id=${id}`)
        let _data = globals.sortArray(r.data)
        this.stateProvinces = []
        let _items = []
        for (let item of _data) {
          item.value = parseInt(item.id)
          _items.push(item)
        }
        this.stateProvinces = JSON.parse(JSON.stringify(Object.assign(this.stateProvinces, _items)))
        if (this.lookups['StateProvince'] !== undefined && this.lookups['StateProvince'] !== null) {
          this.lookups['StateProvince'] = this.stateProvinces
        }
      },
      async setLanguages() {
        const r = await http.get('lookup/Languages')
        let _data = globals.sortArray(r.data)
        this.languages = []
        let _items = []
        for (let item of _data) {
          item.value = parseInt(item.id)
          _items.push(item)
        }
        this.languages = JSON.parse(JSON.stringify(Object.assign(this.languages, _items)))
      },
      async getCountryCode(id) {
        let code = null
        this.lookups['Country'].forEach(element => {
          if (parseInt(element.value) === parseInt(id)) {
            code = element.code
          }
        })
        return code
      },
      async getStateProvinceAbbr(id) {
        let abbr = null
        this.lookups['StateProvince'].forEach(element => {
          if (parseInt(element.value) === parseInt(id)) {
            abbr = element.name
          }
        })
        return abbr
      }
  }
})
